import type { CSSProperties } from "react"

import type { RobinState } from "./robin-state"

/**
 * The padded frame every `public/robin-states/robin-avatar-*.svg` is drawn in.
 * Mirrors the `frame` block that scripts/generate-robin-avatar-states.mjs
 * writes to robin-avatar-states.json; a unit test keeps the two in step.
 *
 * Robin himself is a 128-unit mark. The file's viewBox is padded around him
 * (and centred on the rings' origin) so the state rings can travel past his
 * silhouette instead of being clipped into arcs at the file's edge.
 */
export const ROBIN_AVATAR_FRAME = {
  minX: -24,
  minY: -20,
  size: 176,
  mark: 128,
} as const

export function robinAvatarSrc(state: RobinState): string {
  return `/robin-states/robin-avatar-${state}.svg`
}

/**
 * Lays the padded file over a box sized to the mark: the image is scaled up
 * by the padding ratio and offset so the mark lands exactly on the box, and
 * the padding — where the rings live — overflows around it.
 */
export function robinAvatarFrameStyle(): CSSProperties {
  const { minX, minY, size, mark } = ROBIN_AVATAR_FRAME
  const pct = (units: number) => `${(units / mark) * 100}%`
  return {
    width: pct(size),
    height: pct(size),
    left: pct(minX),
    top: pct(minY),
  }
}
